import React, { Component } from 'react'
import StudentPV from './StudentPV'
import AuthA from '../../store/actions/AuthA'
import {connect} from 'react-redux'

import axios from 'axios'

class StudentPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      student: {}
    };
    this.getStudent = this.getStudent.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  getStudent() {
    const id = this.props.match.params.id;

    axios.get(process.env.REACT_APP_URL+'/students/'+id)
    .then(response => {
      this.setState({ student: response.data });
    });
  }

  goBack() {
    this.props.history.goBack();
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Students / Student Profile'});
    this.getStudent();
  }

  render() {
    console.log(this.state.student)
    return (
      <StudentPV
        auth={this.props.auth}
        userType={this.props.userType}
        student={this.state.student}
        goBack={this.goBack}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    userType: state.AuthR.userType
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentPC);
